<template>
  <v-app>

    <v-app-bar app>
      <v-toolbar-title class="headline">
        <span>MistDewing</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>

    <section class="section-footer">
      <div class="v-footer-deep">
        <v-footer>
          <v-layout justify-center>
            <div class="section-copyright">
              Copyright © {{getCopyrightYear}} MistDewing
            </div>
          </v-layout>
        </v-footer>
      </div>
    </section>

  </v-app>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data: () => ({
    //
  }),
  computed: {
    getCopyrightYear: function () {
      const year = new Date().getFullYear()
      return `2013-${year}`
    }
  }
}
</script>

<style scoped lang="scss">
  .section-footer {
    background-color: #141414 !important;
  }
  .section-copyright {
    color: #666;
  }
</style>

<style scoped>
  .v-footer-deep >>> .theme--light.v-footer {
    background-color: transparent;
  }
</style>
